<template>
  <div class="ProjectExportThumbnail" style="position:relative;">
    <h3>{{ item.name | ellipsis(30) }}</h3>
    <div v-show="selected">
      <i
        class="fa fa-check-circle"
        style="color: #31287c; font-size: 24px; position:absolute;z-index: 1; right: -4px;top: -8px;"
      ></i>
    </div>
    <div class="ProjectExportThumbnail__overlay">
      <div class="ProjectExportThumbnail__overlay__items">
        <div
          style="color: white;"
          @click="$router.push(`/export/fiche_projet/${item.uuid}`)"
        >
          <i class="fa fa-file" style="font-size: 48px;"></i>
          <span style="font-size: 13px;">faire une fiche</span>
        </div>
        <div
          style="color: white;"
          :style="{ background: selected ? '#7a282899' : '' }"
          @click="$emit('update:selected', !selected)"
        >
          <i
            class="fa"
            :class="!selected ? 'fa-check-circle' : 'fa-times-circle'"
            style="font-size: 48px;"
          ></i>
          <span style="font-size: 13px;"
            >{{ selected ? "dé" : "" }}sélectionner</span
          >
        </div>
      </div>
      <api-picture-cropped
        :style="{ filter: selected ? 'none' : 'grayscale(65%)' }"
        :ratio="16 / 9"
        :picture-id="item.main_image"
      ></api-picture-cropped>
    </div>
  </div>
</template>

<script>
import ApiPictureCropped from "../Layout/ApiPictureCropped";

export default {
  name: "ProjectExportThumbnail",
  components: { ApiPictureCropped },
  props: {
    item: {},
    detailed: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.ProjectExportThumbnail {
  padding: 2px;
  border-radius: 2px;
  border: 1px solid #ddd;
  background: white;
  font-size: 11px;
  &__controls {
    display: flex;
    justify-content: space-between;
    padding: 2px;
    font-size: 11px;
  }
  &__overlay {
    cursor: pointer;
    &:hover {
      .ProjectExportThumbnail__overlay__items {
        opacity: 1;
      }
    }
    position: relative;
    &__items {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      background: #31287ccc;
      display: flex;
      z-index: 1;
      transition: opacity 0.3s;
      & > div {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        flex: 1;
        &:hover {
          background: #31287ccc;
        }
      }
    }
  }
}
</style>
